import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import './HomePage.css';
import Footer from './Footer';

const HomePage = () => {
  const { t } = useLanguage();
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const { innerWidth, innerHeight } = window;
      const x = (e.clientX / innerWidth - 0.5) * 30;
      const y = (e.clientY / innerHeight - 0.5) * 30;
      setOffset({ x, y });
    };

    const handleDeviceOrientation = (e) => {
      if (e.gamma === null || e.beta === null) return;
      const x = (e.gamma / 45) * 15;
      const y = ((e.beta - 45) / 45) * 15;
      setOffset({ x: Math.max(-15, Math.min(15, x)), y: Math.max(-15, Math.min(15, y)) });
    };

    if ('ontouchstart' in window) {
      window.addEventListener('deviceorientation', handleDeviceOrientation);
    } else {
      window.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('deviceorientation', handleDeviceOrientation);
    };
  }, []);

  return (
    <div className="home-container" ref={containerRef}>
      <div
        className="parallax-overlay"
        style={{
          transform: `translate(${offset.x}px, ${offset.y}px)`,
          backgroundImage: `url(${process.env.PUBLIC_URL}/Ativo_1.png)`
        }}
      />
      <div className="home-content">
        <div className="logo-section">
          <div className="logo-wrapper">
            <div className="logo-circle">
              <img src="/logo.png" alt="IGL Coatings Logo" />
            </div>
          </div>
          <h1 className="logo-text">IGL Coatings</h1>
          <p className="subtitle">{t('home.subtitle')}</p>
        </div>
        
        <div className="buttons-section">
          <Link to="/login" className="btn btn-primary">
            <div className="btn-content">
              <span className="btn-text">{t('home.btnApplicator')}</span>
            </div>
          </Link>
          
          <Link to="/buscar-certificado" className="btn btn-secondary">
            <div className="btn-content">
              <span className="btn-text">{t('home.btnCertificate')}</span>
            </div>
          </Link>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default HomePage;
